export const isRecord = (value)=>typeof value === 'object' && value !== null;
const EMPTY_MARKERS = new Set([
    '',
    '-',
    '–',
    '—'
]);
export const isEmptyMarker = (value)=>EMPTY_MARKERS.has(value.trim());
export const asString = (value)=>typeof value === 'string' && !isEmptyMarker(value) ? value : undefined;
export const asStringList = (value)=>Array.isArray(value) ? value.filter((entry)=>typeof entry === 'string') : [];
